/** True on routes where the AI chat pane is available (home, datasets, boards — including their index pages). */
export const isChatPaneRoute = (pathname: string): boolean =>
  pathname === "/" ||
  pathname === "/datasets" ||
  pathname.startsWith("/datasets/") ||
  pathname === "/boards" ||
  pathname.startsWith("/boards/");

/** True on the full-page thread view (`/thread/$threadId`). */
export const isThreadRoute = (pathname: string): boolean =>
  pathname.startsWith("/thread/");
